module.exports = __webpack_public_path__ + "img/CNS.119a86c9.png";